import { Component, Input } from '@angular/core';

/**
 * Pass null to hide the text.
 */
@Component({
  selector: 'app-shared-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  @Input() text?: string | null;
  @Input() position?: 'left' | 'center' = 'center';
}
